import { Data$ } from '@lycoris-nubila/ngx-lycoris';
import { Observable } from 'rxjs';

import { ObserveJobOffersByOwnerIdAndOrganizationModuleIdQuery } from 'application/job/query/observe-job-offers-by-owner-id-and-organization-module-id.query';
import { MoveJobOfferToColumnCmd } from 'job/command/move-job-offer-to-column.cmd';
import { UpdateJobOfferDocumentCmd } from 'job/command/update-job-offer-document.cmd';
import { IJobOffer, JobOffer } from 'job/job-offer';
import { JobOfferDocumentOutput } from 'job/model/job-offer-document.output';

import { SaveJobOfferCmd } from '../command/save-job-offer.cmd';

export abstract class JobOfferApplicationPort {
	public abstract saveJobOffer(cmd: SaveJobOfferCmd): Observable<void>;

	public abstract observeJobOffersByOwnerIdAndOrganizationModuleId(
		query: ObserveJobOffersByOwnerIdAndOrganizationModuleIdQuery
	): Data$<IJobOffer[]>;

	public abstract moveJobOfferToColumn(
		cmd: MoveJobOfferToColumnCmd
	): Observable<void>;

	public abstract observeAttachedJobOffersByIds(
		ids: string[]
	): Observable<JobOffer[]>;

	public abstract observeJobOfferById(id: string): Data$<IJobOffer>;

	public abstract generateJobOfferDocumentUrl(
		file: File
	): Observable<JobOfferDocumentOutput>;

	public abstract updateJobOfferDocument(
		cmd: UpdateJobOfferDocumentCmd
	): Observable<IJobOffer>;
}
